import React from 'react'
import Footer from '../../components/Footer'
import PharmacyImg from "../../assets/images/diplomao.jpeg";
import { Link } from 'react-router-dom';
import { ChevronRight, Award, Cake, Utensils, PieChart } from 'lucide-react';
import Title from '../../components/TitleComponent';
const DiplomaConfectionary = () => {
  return (
    <div className='w-full relative font-poppins bg-gray-50'>
      <Title canonicalPath="/programmes/diploma-courses/best-bakery-and-confectionery-college-in-dehradun-uttarakhand" />
      <Title title="Diploma in Bakery and Confectionery at Maya Devi University" description="Join the Diploma in Bakery and Confectionery program at Maya Devi University, Dehradun. Learn baking techniques, pastry skills, and start a sweet career!" />
      <div className='w-10/12 mx-auto mt-[100px] md:mt-[150px] flex flex-col gap-5 md:gap-5'>
        <div className='text-center'>
          <h2 className='mb-4 text-2xl md:text-6xl tracking-tight font-bold text-[#0e4d38] relative'>
            Diploma in Bakery and Confectionary
            <div className='w-[20%] mx-auto h-[6px] bg-[#23376c] mt-[-10px] md:mt-[-20px] absolute left-1/2 transform -translate-x-1/2 bottom-[-15px]'></div>
          </h2>
        </div>

        <div className='flex flex-col md:flex-row gap-8 mb-10 md:gap-[80px] mt-5 justify-center md:justify-between items-center'>
          <img 
            src={PharmacyImg} 
            alt="Bakery and Confectionary"
            className='md:w-[40%] rounded-lg shadow-lg transition-transform duration-300 hover:scale-105'
          />
          <div className='flex flex-col gap-4 md:w-1/2'>
            <h4 className='font-bold text-xl md:text-3xl text-[#23376c]'>About the Department</h4>
            <p className='text-justify md:text-lg text-gray-700'>
              The Diploma in Bakery and Confectionary is an extensive 1 ½ year program aimed at equipping students for fulfilling careers in the hospitality sectors. This comprehensive and hands-on course provides students with the skills and knowledge necessary to excel in the baking and pastry arts industry. The program combines theoretical learning with practical experience, ensuring students are well-equipped to pursue diverse careers in the dynamic world of bakery and confectionary.
            </p>
            <Link to="https://admission.maya.edu.in/" className='self-start'>
              <button className='mt-5 md:mt-0 bg-[#23376c] px-6 py-3 text-white rounded-full font-semibold transition-all duration-200 hover:bg-[#4865b3] flex items-center gap-2 group'>
                Register Now
                <ChevronRight className='group-hover:translate-x-1 transition-transform' size={20} />
              </button>
            </Link>
          </div>
        </div>

        {/* Programme Details Table */}
        <div className="bg-white shadow-md rounded-lg overflow-x-auto mb-10">
          <table className="min-w-full text-center text-sm font-light">
            <thead className="bg-[#23376c] text-white">
              <tr>
                <th className="px-6 py-4 font-semibold">Programme</th>
                <th className="px-6 py-4 font-semibold">Branch</th>
                <th className="px-6 py-4 font-semibold">Duration</th>
                <th className="px-6 py-4 font-semibold">Seats</th>
                {/* <th className="px-6 py-4 font-semibold">One-time Charges</th> */}
                {/* <th className="px-6 py-4 font-semibold">Yearly Fee (India)</th>
                <th className="px-6 py-4 font-semibold">Yearly Fee (UK)</th> */}
              </tr>
            </thead>
            <tbody>
              <tr className="border-b">
                <td className="whitespace-nowrap px-6 py-4 font-semibold">Diploma</td>
                <td className="whitespace-nowrap px-6 py-4">Bakery and Confectionary</td>
                <td className="whitespace-nowrap px-6 py-4">1</td>
                <td className="whitespace-nowrap px-6 py-4">20</td>
                {/* <td className="whitespace-nowrap px-6 py-4">Rs.11000/-</td> */}
                {/* <td className="whitespace-nowrap px-6 py-4">Rs.60000/-</td>
                <td className="whitespace-nowrap px-6 py-4">Rs.45000/-</td> */}
              </tr>
            </tbody>
          </table>
        </div>

        {/* Course Details Sections */}
        <div className='grid md:grid-cols-2 gap-10 mb-[100px]'>
          <div className='bg-white p-6 rounded-lg shadow-md'>
            <h4 className='text-2xl font-semibold text-[#0e4d38] mb-4 flex items-center'>
              <Award className='mr-3 text-[#23376c]' /> Eligibility Criteria
            </h4>
            <p>10+2 (In any Stream)</p>
          </div>

          <div className='bg-white p-6 rounded-lg shadow-md'>
            <h4 className='text-2xl font-semibold text-[#0e4d38] mb-4 flex items-center'>
              <Utensils className='mr-3 text-[#23376c]' /> Career Prospects
            </h4>
            <ul className='list-disc pl-5 space-y-2'>
              <li>Hotel Industry</li>
              <li>Catering Service</li>
              <li>Cruise Industry</li>
              <li>Management</li>
              <li>Retail Management</li>
              <li>Event Management Companies</li>
            </ul>
          </div>

          <div className='bg-white p-6 rounded-lg shadow-md'>
            <h4 className='text-2xl font-semibold text-[#0e4d38] mb-4 flex items-center'>
              <Cake className='mr-3 text-[#23376c]' /> Career Options
            </h4>
            <ul className='list-disc pl-5 space-y-2'>
              <li>Pastry Chef</li>
              <li>Bakery Manager</li>
              <li>Cake Decorator</li>
              <li>Chocolatier</li>
              <li>Confectionary Artist</li>
              <li>Entrepreneur (Bakery Owner)</li>
            </ul>
          </div>
        </div>
      </div>
      <Footer/>
    </div>
  )
}

export default DiplomaConfectionary